<div [class.highlight]="view.highlight">
  <!-- Customization -->
  <classic-checkbox *ngIf="type == 'classic'" [view]="view" [viewValue]="view.value" [cusPrice]="cusPrice"></classic-checkbox>
  <!-- End of customization -->
  <standard-checkbox *ngIf="type == 'standard'" [view]="view"></standard-checkbox>
</div>
<div *ngFor="let error of _errors" class="form-control-feedback d-block">{{error}}</div>